import { render, staticRenderFns } from "./Siparisler.vue?vue&type=template&id=d3891476&scoped=true&"
import script from "./Siparisler.vue?vue&type=script&lang=js&"
export * from "./Siparisler.vue?vue&type=script&lang=js&"
import style0 from "./Siparisler.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Siparisler.vue?vue&type=style&index=1&id=d3891476&lang=scss&scoped=true&"
import style2 from "./Siparisler.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3891476",
  null
  
)

export default component.exports